































import {Component, Vue, Watch} from "vue-property-decorator";
import HistoryTabContent from "@/components/for-counters-values/HistoryTabContent.vue";
import {mapGetters, mapMutations} from "vuex";
import XSlider from "@/components/SimpleSlider.vue";
import CounterHistoryTable from "./CounterHistoryTable.vue";
import InvisibleWall from "@/components/InvisibleWall.vue";
import SimpleFilterTU from "@/components/SimpleFilterTU.vue";

@Component({
  components: {
    SimpleFilterTU,
    HistoryTabContent,
    XSlider,
    CounterHistoryTable,
    InvisibleWall,
  },
  computed: {
    ...mapGetters({
      sortedPointsByObject: "accountingPoints/sortedPointsByObject",
      pointName: "accountingPoint/devicePointName",
      pointNumber: "accountingPoint/devicePointNumber",
      contractType: "contract/type"
    }),
  },
  methods: {
    ...mapMutations("accountingPoints",
      {
        setUseHistoryList: "setUseHistoryList",
        setUseMeteringPointSorting: "setUseMeteringPointSorting"
      })
  }
})

class ValuesHistory extends Vue {
  [x: string]: any;
  showPointDetails = false;
  showWall = false;
  itemsTU = [];

  setDefaultDate = true; // устанавливаем даты по умолчанию при первом открытии
  chosenCounter = -1; // ПУ, по которому отображается история
  @Watch('chosenCounter')
  chosenCounterChanged() {
    // устанавливаем новые даты только при смене ПУ
    this.setDefaultDate = true;
  }
  @Watch('showPointDetails')
  showPointDetailsChanged(newValue) {
    if (!newValue) {
      // при закрытии слайдера сбрасываем флаг установки новых дат
      this.setDefaultDate = false;
    }
  }

  mounted() {
    this.setUseHistoryList(true);
    this.contractType !== 3 && this.setUseMeteringPointSorting(true);
    this.itemsTU = this.sortedPointsByObject;
  }
  destroyed() {
    this.setUseHistoryList(false);
    this.setUseMeteringPointSorting(false);
  }
}

export default ValuesHistory
